import React, { Component } from 'react'
import {Header,Loader, Divider} from 'semantic-ui-react'
import '../App.css'
import {ComposedChart, Line, XAxis, YAxis, CartesianGrid,  Tooltip, Legend, ResponsiveContainer} from 'recharts';
import DefaultTooltipContent from 'recharts/lib/component/DefaultTooltipContent';
import { toast } from '../../node_modules/react-toastify';
import {bindActionCreators} from 'redux';
import * as tokenActions from '../actions/actions';
import {connect} from 'react-redux';
var moment = require('moment');
require('moment-timezone');

/*
    This compoenent is responsible for disaplaying a smaller and less detailed versino of the main graph.
    This compoenend is called when a node in the map is selected. The resulting popup should display this compoenent. 
*/
class Tinygraph extends Component {
    constructor(props){
        super(props);
        this.state={
            isGraphDataLoading:true,
            graphNodeData:[]
        }
    }
    componentDidMount(){
        var canberraTime = moment();

        //get data for the last day
        this.props.tokenActions.getNodeGraphData(this.props.searchString, 3, canberraTime.unix() - (86400 * 3),  canberraTime.unix() )
    }
    componentWillReceiveProps(props){
        if(props.getNodeGraphDataSuccessAlert === true){
            this.setState({isGraphDataLoading:false})
           if(!props.graphNodeData || props.graphNodeData.length < 1){
               toast.warn("No data found for this node");
               this.setState({isGraphDataLoading:false})
           }
           if(props.graphNodeData && props.graphNodeData.length > 0){
                this.setState({graphNodeData:props.graphNodeData, dataCount:props.graphNodeData.count},()=>{
                })
           }
        } else{
            toast.warn("Error Loading Data");
            this.setState({isGraphDataLoading:false})
        }
        // this.props.tokenActions.hideAlerts()
    }

    render(){
        const CustomTooltip = props => {
            // payload[0] doesn't exist when tooltip isn't visible
            if (props.payload && props.payload[0] != null) {
                // mutating props directly is against react's conventions
                // so we create a new payload with the name and value fields set to what we want
                const newPayload = [
                {
                    name: 'Date',
                    // all your data which created the tooltip is located in the .payload property
                    value: moment(props.payload[0].payload.upload_timestamp * 1000).format('DD/MM/YY HH:mm'),
                    // you can also add "unit" here if you need it
                },
                ...props.payload,
                ];
            
                // we render the default, but with our overridden payload
                return <DefaultTooltipContent  payload={newPayload} />;
            }
            
            // we just render the default
            return <DefaultTooltipContent {...props} />;
            };
        return(
            <div>
                <div>
                    <Header id = 'renderedNode'>{this.props.title}</Header>

                    <ResponsiveContainer height={200} width='100%'>
                    
                            <ComposedChart  data={this.state.graphNodeData} type={''}
                                    margin={{top: 5, right: 0, left: 0, bottom: 5}}>
                                <XAxis dataKey="upload_timestamp"
                                // name = 'Time'
                                domain = {['auto', 'auto']}
                                tickFormatter = {(unixTime)  => moment(unixTime * 1000).format('DD/MM HH:mm')}
                                type = 'number'
                                
                                />
                                <Tooltip headerFormat= '' content={CustomTooltip} cursor={{ stroke: 'red', strokeWidth: 1 }}
                                        
                                

                                />
                                <YAxis yAxisId="left" />
                                <CartesianGrid strokeDasharray="8 8"/>
                                <YAxis yAxisId="right" orientation="right"/>
                            
                                <Legend />
                                <Line yAxisId="left"  dot={false} type="monotone" dataKey="vwc30" fill='teal'stroke="teal"/>
                                <Line yAxisId="left" dot={false} type="monotone" dataKey="vwc60" fill='blue' stroke = 'blue'/>        
                                <Line yAxisId="right" dot={false} type="monotone" dataKey="temperature" fill='orange' stroke="orange"/>
                                {/* <Line yAxisId="left" dot={false} type="monotone" dataKey="battery" fill='orange' stroke="black"/> */}
                            </ComposedChart>
                        </ResponsiveContainer>
                        
                        {this.state.isGraphDataLoading === true ? <Loader active small content = 'Fetching Data..'/> : null }
                        <Divider/>
                        
                        <div>

                </div>
                        
                    </div>
            </div>
        )
    }

    

}


function mapStateToProps(state) {
    return {
        ...state.initState
    };
}
function mapDispatchToProps(dispatch) {
    return {
        tokenActions: bindActionCreators(tokenActions, dispatch)
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
    
)(Tinygraph);



// WEBPACK FOOTER //
// ./src/components/tinygraph.js